<template>
    <div class="o-promoGroups d-flex flex-column gap-1-5">
        <promo-group
            v-for="group in groups"
            :key="`group-${group.id}`"
            :group="group"
            :preview-type="previewType"
        >
        </promo-group>
    </div>
</template>

<script>
import PromoGroup from '@/components/promotions/PromoGroup'
export default {
    name: 'PromoGroups',
    props: {
        groups: {
            type: Array,
            required: true
        },
        previewType: {
            type: String,
            required: true
        }
    },
    components: {
        PromoGroup
    }
}
</script>
